import apiClient from 'services/_infra/apiClient';

/**
 * List the services the supervisor manages.
 *
 * The Fusion proxy scopes the result to the caller's workplace, read from the
 * verified token rather than from anything the client sends, and always
 * includes globally-scoped services. Pass `{ all: true }` to bypass that and
 * get every workplace's services, which is what the Deployments tab needs.
 *
 * Note that a service whose enable flag is off has no row here at all: the
 * listing is built from the supervisor's registry, and only enabled services
 * are registered. To see or change those, read the catalog
 * (`getWorkplaces`) and use the enable/disable endpoints.
 *
 * @param {{ all?: boolean }} [options]
 * @returns {Promise<{ message: string, data: { success: boolean, services: import('pages/Overwatch/ServicesManager/types/ServiceManager.types').RawService[] } }>}
 *   The Fusion proxy envelope. The supervisor payload is under `.data`; each row is a `RawService`.
 */
export async function getServices({ all = false } = {}) {
  try {
    const res = all
      ? await apiClient.get('/service-manager/services', { params: { all: 'true' } })
      : await apiClient.get('/service-manager/services');

    return res.data;
  } catch (err) {
    console.error('Error fetching services:', err);
    throw err;
  }
}
